// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TeamViewerSupport_wrapper__1cXMh","itemWrapper":"TeamViewerSupport_itemWrapper__2NKiZ","item":"TeamViewerSupport_item__3WJOS","mobile":"TeamViewerSupport_mobile__3ePUC"};